import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { OnboardingData } from "@redotech/redo-merchant-app-common/team";

/**
 * GET /onboarding
 */
export async function getOnboarding(
  client: RedoMerchantClient,
  { signal, teamId }: { signal?: AbortSignal; teamId: string },
): Promise<OnboardingData> {
  const response = await client.client.get("team/onboarding", {
    headers: client.authorization(),
    params: { teamId },
    signal,
  });
  return response.data;
}
